module.exports = __webpack_public_path__ + "img/waveBg.ddb81d45.png";